import { EnvironmentUtil } from "services/util/EnvironmentUtil";
import { ApiVersion } from "./ApiVersion";

export const getApiUrl = (url: string, version: ApiVersion) =>
  version === ApiVersion.V2 ? EnvironmentUtil.apiV2Url(url) : EnvironmentUtil.apiV1Url(url);

export const getApiPortControlUrl = (url: string) => EnvironmentUtil.apiPortControlUrl(url);

export const getApiUrlAtlas = (url: string) => EnvironmentUtil.apiV3Url(url);
